import type { PlacePrediction } from "@/lib/googleMaps/types";
import type { LocationMap } from "./types";

/**
 * The single point where a Google shape becomes an app shape. Legacy
 * predictions exposed `description` and `place_id`; the new API exposes
 * `text.text` and `placeId`.
 */
export function toLocationMap(prediction: PlacePrediction): LocationMap {
  const description = prediction.text.text;

  return {
    description,
    place_id: prediction.placeId,
    label: description,
  };
}
